import type { FC } from 'react';
import { Outlet } from 'react-router-dom';

import { ContentWrapStyled, LayoutStyled } from './WIPPageLayout.styled';

const MAIN_HEADER_OFFSET_PX = 64;

const WIPPageLayout: FC = (): JSX.Element => (
  <LayoutStyled headerOffsetPx={MAIN_HEADER_OFFSET_PX}>
    <ContentWrapStyled>
      <Outlet />
    </ContentWrapStyled>
  </LayoutStyled>
);

export default WIPPageLayout;
